
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vip/[...params]",
      function () {
        return require("private-next-pages/vip/[...params].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vip/[...params]"])
      });
    }
  